import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pfeil",
  "use": "pfeil-usage",
  "viewBox": "0 0 273 523.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 273 523.3\" id=\"pfeil\"><style>#pfeil .st0{fill:none;stroke:#000;stroke-width:16}</style><path id=\"pfeil___2px\" class=\"st0\" d=\"M267.3 5.7l-256 256 256 256\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/pfeil.svg
// module id = 285
// module chunks = 6